import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { ArrowLeft, Sun, CloudRain, Wind, Moon } from 'lucide-react';
export function SafeSpace() {
  return <div className="bg-zen-bg min-h-screen text-zen-text" data-id="element-157">
      <Navbar data-id="element-158" />
      <main className="pt-32 pb-20 px-6" data-id="element-159">
        <div className="max-w-4xl mx-auto" data-id="element-160">
          <a href="/" className="inline-flex items-center gap-2 text-zen-text/60 hover:text-zen-accent mb-8 transition-colors" data-id="element-161">
            <ArrowLeft className="w-4 h-4" data-id="element-162" /> Back to Home
          </a>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-5xl md:text-6xl font-moon-dance mb-6" data-id="element-163">
            My Safe Space
          </motion.h1>

          <p className="text-xl text-zen-text/70 mb-16 leading-relaxed max-w-2xl" data-id="element-164">
            A digital sanctuary for grounding, breathing, and finding balance
            when the world feels too loud.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-165">
            <div className="bg-rose-50/50 p-10 rounded-3xl border border-rose-100" data-id="element-166">
              <h3 className="text-3xl font-moon-dance text-rose-800 mb-6" data-id="element-167">
                Daily Affirmations
              </h3>
              <ul className="space-y-4" data-id="element-168">
                {['I am enough just as I am.', 'My peace is my priority.', 'I trust the timing of my life.', 'I release what I cannot control.'].map((item, i) => <li key={i} className="flex items-center gap-3 text-rose-700/80" data-id="element-169">
                    <Sun className="w-5 h-5" data-id="element-170" />
                    <span className="font-medium" data-id="element-171">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="bg-blue-50/50 p-10 rounded-3xl border border-blue-100" data-id="element-172">
              <h3 className="text-3xl font-moon-dance text-blue-800 mb-6" data-id="element-173">
                Comfort Playlist
              </h3>
              <div className="space-y-4" data-id="element-174">
                {[{
                title: 'Weightless',
                artist: 'Marconi Union'
              }, {
                title: 'River Flows in You',
                artist: 'Yiruma'
              }, {
                title: 'Spiegel im Spiegel',
                artist: 'Arvo Pärt'
              }].map((song, i) => <div key={i} className="flex items-center justify-between p-3 bg-white/60 rounded-xl" data-id="element-175">
                    <div className="flex items-center gap-3" data-id="element-176">
                      <div className="w-8 h-8 bg-blue-200 rounded-full flex items-center justify-center" data-id="element-177">
                        <Moon className="w-4 h-4 text-blue-700" data-id="element-178" />
                      </div>
                      <div data-id="element-179">
                        <p className="font-bold text-blue-900 text-sm" data-id="element-180">
                          {song.title}
                        </p>
                        <p className="text-blue-700/60 text-xs" data-id="element-181">
                          {song.artist}
                        </p>
                      </div>
                    </div>
                    <button className="text-blue-500 hover:text-blue-700" data-id="element-182">
                      ▶
                    </button>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="mt-12 bg-white p-10 rounded-3xl shadow-sm text-center border border-zen-text/5" data-id="element-183">
            <CloudRain className="w-12 h-12 text-zen-text/30 mx-auto mb-6" data-id="element-184" />
            <h3 className="text-2xl font-serif mb-4" data-id="element-185">Rainy Day Mode</h3>
            <p className="text-zen-text/60 mb-8 max-w-md mx-auto" data-id="element-186">
              Sometimes we just need to listen to the rain and let the world
              wash away for a moment.
            </p>
            <button className="px-8 py-3 bg-zen-text text-white rounded-full hover:bg-zen-accent transition-colors" data-id="element-187">
              Start Rain Sounds
            </button>
          </div>
        </div>
      </main>
      <Footer data-id="element-188" />
    </div>;
}